var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"defectiveGoods"},[_c('div',{staticClass:"reportBasic-subTitle"},[_vm._v("\n    "+_vm._s(_vm.$tc('lang.ReportsDetail.DEFECTS_DISPOSAL'))+"\n  ")]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Defective_Product_Area')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.defectiveGoods.defectarea,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Vendor_Representative_Confirmed')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.defectiveGoods.groupphoto,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.QC_Confirmed')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.defectiveGoods.qcgroupphoto,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.replace')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.defectiveGoods.replace,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Untreated')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.defectiveGoods.Untreated,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Rework')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.defectiveGoods.rework,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-table"},[_c('a-table',{staticClass:"desOfGoods-table1",attrs:{"columns":_vm.columns,"dataSource":_vm.data,"bordered":"","pagination":false,"rowKey":"id"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }